import CancelIcon from "@mui/icons-material/Cancel";
import StatusModal from "@components/StatusModal/StatusModal";

const FailurePage = () => {
  //test
  return (
    <StatusModal
      paymentStatus="Error"
      statusDescription="An error occurred. 
                   Please try again!"
      icon={<CancelIcon sx={{ color: "#f44336", fontSize: 50 }} />}
    />
  );
};

export default FailurePage;
